import React from 'react'

export default function Success() {
  return (
    <div className='text-center p-24 text-2xl font-bold'>
      Payment Success
    </div>
  )
}
